import gsap from 'gsap'

let headerConfiguration = {
    /**
     * Component name
     * @type {String}
     */
    name: 'main-header',

    /**
     * Component
     */
    $component: {},

    /** Data
     * @type {Object}
     */
    $data: {
        uiMask: {},
        mainMenuTimeline: {},
        mobileMenuOpen: false
    },

    /**
     * Create components
     * @void
     */
    init () {
        console.log('HEADER Initialized')
        this.$component = document.querySelector(`.${this.name}`)
        this.$data.uiMask = document.querySelector('.app-mask')

        // function
        this.initMenuTimeline()
        this.setActiveMenu()
        this.attachEventsHandlers()
    },

    /**
     * Attach event handlers
     */
    attachEventsHandlers () {
        const TOGGLE_MENU = this.$component.querySelector('.toggle-menu')

        // toggle menu
        TOGGLE_MENU.addEventListener(
            'click',
            () => {
                this.toggleMenu()
            }
        )

        // windows resize
        window.addEventListener(
            'resize',
            () => {
                this.onWindowsResize()
            }
        )
    },

    /**
     * Init menu timeline
     */
    initMenuTimeline () {
        this.$data.mainMenuTimeline = gsap.timeline(
            {
                paused: true,
                yoyo: true,
                onStart: () => {
                    this.$component.classList.add('main-menu-open')
                },
                onReverseComplete: () => {
                    this.$component.classList.remove('main-menu-open')
                }
            }
        )

        this.$data.subMenuTimeline = gsap.timeline(
            {
                paused: true,
                yoyo: true
            }
        )

        this.$data.mainMenuTimeline
            .to(
                '.nav-main',
                {
                    x: 0,
                    duration: 1,
                    ease: 'power2.out'
                }
            )
            .to(
                '.toggle-menu',
                {
                    x: window.innerWidth < 1024 ? (window.innerWidth - 75) : 0,
                    duration: 1,
                    ease: 'power2.out'
                },
                0.2
            )
            .from(
                '.nav-main .separator',
                {
                    duration: 2,
                    scale: window.innerWidth < 1024 ? 0 : 1,
                    ease: 'power2.out'
                },
                0.5
            )
            .from(
                '.nav-main .nav-main-list-wrapper > ul li',
                {
                    duration: 1,
                    y: window.innerWidth < 1024 ? 100 : 0,
                    autoAlpha: window.innerWidth < 1024 ? 0 : 1,
                    ease: 'power2.out',
                    yoyo: true,
                    clearProps: 'all',
                    stagger: 0.1
                },
                1
            )
            .reverse()
    },

    /**
     * on Windows resize
     */
    onWindowsResize () {
        this.$data.mobileMenuOpen = false

        if (this.$data.mainMenuTimeline) {
            this.$data.mainMenuTimeline
                .clear()
                .kill()
        }

        this.$component.classList.remove('main-menu-open')

        gsap.set(
            [
                '.nav-main',
                '.toggle-menu',
                '.nav-main .separator',
                '.nav-main .nav-main-list-wrapper > ul li'
            ],
            { clearProps: 'all' }
        )

        this.initMenuTimeline()
    },

    /**
     * Toggle menu
     */
    toggleMenu () {
        if (this.$data.mainMenuTimeline) {
            this.$data.mobileMenuOpen = !this.$data.mobileMenuOpen

            this.$data.mainMenuTimeline
                .duration(this.$data.mobileMenuOpen ? 2 : 1)
                .reversed(!this.$data.mobileMenuOpen)
        }
    },

    hideMenu () {
        if (this.$data.mainMenuTimeline && window.innerWidth < 1024) {
            this.$data.mobileMenuOpen = false

            this.$data.mainMenuTimeline
                .duration(this.$data.mobileMenuOpen ? 2 : 1)
                .reversed(!this.$data.mobileMenuOpen)
        }
    },

    /**
     * Set active menu on page load
     */
    setActiveMenu (location = window.location) {
        let _links = this.$component.querySelectorAll('.nav-main .nav-main-list > li > a')
        let _currentIndex = 0

        _links.forEach(
            (link, index) => {
                let _activeMenu = link.parentNode

                _activeMenu.classList.remove('is-active')
                link.removeAttribute('data-transition')

                // Active link
                if (link.href === location.href.split('#')[0]) {
                    _currentIndex = index
                    _activeMenu.classList.add('is-active')
                }
            }
        )

        let _linkBefore = Array.from(_links)

        _linkBefore = _linkBefore.slice((_currentIndex + 1), _links.length)
        _linkBefore.forEach(
            _link => {
                _link.setAttribute('data-transition', 'reverse')
            }
        )

        if (_links.length > 0) {
            let _circle = _links[_currentIndex].querySelector('.circle-hour')
            let _style = window.getComputedStyle(_circle)

            document.body
                .style
                .setProperty(
                    '--current-color',
                    _style.backgroundColor
                )
        }
    },

    getoffsetHeight () {
        return this.$component.offsetTop + this.$component.offsetHeight
    }
}

/**
 * Module export
 */
export default headerConfiguration
